
export const APP_ROUTES = {
  DASHBOARD: '/dashboard',
  COMPANY_KNOWLEDGE_BASE: '/knowledgebase',
  KB_SOURCE_PATH: '/knowledgebase/sources/:sourceKey',
  kbSource: (sourceKey: string) => `/knowledgebase/sources/${encodeURIComponent(sourceKey)}`,
  COMPETITORS: '/competitors',
  WRITING_STYLES: '/writingstyles',
  WRITING_STYLE_NEW: '/writingstyles/new',
  WRITING_STYLE_EDIT_PATH: '/writingstyles/:id',
  writingStyleEdit: (id: number | string) => `/writingstyles/${id}`,
  PERSONAS: '/personas',
  COMPANY_BRAND_VOICE: '/brandvoice',
  COMPANIES: '/companies',
  COMPANY_NEW: '/companies/new',
  COMPANY_EDIT_PATH: '/companies/:id',
  companyEdit: (id: number | string) => `/companies/${id}`,
  COMPANY_MEDIA_PATH: '/companies/:companyId/media',
  companyMedia: (companyId: number | string) => `/companies/${companyId}/media`,
  MEDIA: '/media',
  PRODUCTS: '/products',
  PRODUCT_NEW: '/products/new',
  PRODUCT_EDIT_PATH: '/products/:id',
  productEdit: (id: number | string) => `/products/${id}`,
  CAMPAIGNS: '/campaigns',
  CAMPAIGN_NEW: '/campaigns/new',
  CAMPAIGN_EDIT_PATH: '/campaigns/:id',
  campaignEdit: (id: number | string) => `/campaigns/${id}`,
  SOURCE_CONTENTS: '/sourcecontents',
  SOURCE_CONTENT_NEW: '/sourcecontents/new',
  SOURCE_CONTENT_EDIT_PATH: '/sourcecontents/:id',
  CONTENTS: '/contents',
  CONTENT_NEW: '/contents/new',
  CONTENT_EDIT_PATH: '/contents/:id',
  contentEdit: (id: number | string) => `/contents/${id}`,
  contentOptimize: (id: number | string) => `/contents/${id}?tab=optimize`,
  SUGGESTIONS: '/suggestions',
  CHANNELS: '/channels',
  TRUST_SIGNAL_DETAIL_PATH: '/assets/:id',
  trustSignalDetail: (id: number | string) => `/assets/${id}`,
  COMPANY_TRUST_SIGNAL: '/trustsignal',
  SETTINGS: '/settings',
  SETTINGS_TAB_PATH: '/settings/:tab',
  settingsTab: (tab: string) => `/settings/${tab}`,
  PROFILE: '/profile',
  PROFILE_TAB_PATH: '/profile/:tab',
  profileTab: (tab: string) => `/profile/${tab}`,
  USER_NEW: '/settings/users/new',
  USER_EDIT_PATH: '/settings/users/:id',
  userEdit: (id: number | string) => `/settings/users/${id}`,
  ROLE_NEW: '/settings/roles/new',
  ROLE_EDIT_PATH: '/settings/roles/:id',
  roleEdit: (id: number | string) => `/settings/roles/${id}`,
  SUBSCRIPTION: '/subscription',
  EDITORIAL_CALENDAR: '/calendar',
  ANALYSIS: '/analysis',
  ONBOARDING: '/onboarding',
  RESCAN: '/visibilityReport',
  SITE_HEALTH: '/site-health',
  SITE_HEALTH_HISTORY: '/site-health/history',
  SITE_HEALTH_DETAIL_PATH: '/site-health/:id',
  siteHealthDetail: (id: number | string) => `/site-health/${id}`,
} as const;

export default APP_ROUTES;